import React, { Component } from "react";
import Icon from "../../../icon";
import Translation from "../../../common/translation/translation.component";
import { DASHBOARD_TAB } from "../../../../utils/constant.utils";
import ProfileImage from "../../../../../img/AT&T.png";
import Avatar from "../../../common/avatar/Avatar";
import { CIRCUIT_STATUS } from "../../../../constants/external-constants";

export class VerticalTab extends Component {

    getLocationAndZipCode = (location, zipCode) => {
        var locationAndZipCode = "";
        if (location && location.trim() !== "") locationAndZipCode = location
        if (zipCode && zipCode.trim() !== "") locationAndZipCode = `${location} ${zipCode}`;

        return locationAndZipCode;
    }

    getCityAndCountryCode = (city, countryCode) => {
        var cityAndCountryCode = "";
        if (city && city.trim() !== "") cityAndCountryCode = city
        if (countryCode && countryCode.trim() !== "") cityAndCountryCode = `${cityAndCountryCode}, ${countryCode}`;

        return cityAndCountryCode;
    }
    
    render() {       
        const { tabItem, tabCount, toggleTab, onClickItem, stringSearched, planInfo, equipmentModel } = this.props
        if (tabItem.isFetching) {
            return <p className="string-result-style">Loading subscription and devices...</p>
        } else if (tabItem.Data.length === 0 && stringSearched.length !== 0) {
            return <p className="string-result-style"><Translation translationKey="no_results_found_for" /> {`"${stringSearched}"`}</p>/*<Translation translationKey="no_results_found" />*/

        } else if (tabItem.Data.length === 0 && stringSearched.length === 0) {
            return <p className="string-result-style"><Translation translationKey="no_results_found" /></p>
        }
        else {
            return (

               tabItem.Data.slice(0, tabCount).map((item, id) =>
                    <div key={id} data-index={item.CircuitId} className={`vertical-tab-container vertical-tab-item`} onClick={onClickItem}>
                        {toggleTab === DASHBOARD_TAB.MobileWireless ? 
                           <Avatar className="tab-client-logo" src={item.LogoPath} text={item.VendorName} />
                            : ""
                        }
                        <div className="tab-details">
                           <h1 className="tab-details-phonenumber">{item.CircuitCode}</h1>
                           <h2 className={`tab-details-office ${item.CircuitStatus === CIRCUIT_STATUS.inService.name ? "status-inservice" : "status-suspended"}`}>
                               {item.CircuitStatus}
                           </h2>
                           <h2 className="tab-details-office">{item.VendorName}</h2>
                           <h2 className="tab-details-office">{(item.PlanName === null || item.PlanName === '') ? <Translation translationKey="no_plan_available" /> : item.PlanName} </h2>
                           <h2 className="tab-details-office">{(item.DeviceName === null || item.DeviceName === '') ? <Translation translationKey="no_device_available" /> : item.DeviceName}</h2>
                   
                            {item.IsPrimaryNumber ?
                                <Icon
                                    customClassName="icon-check"
                                    name="check-circle-solid"
                                    labelValue={<Translation translationKey="primary" />}
                                    size="15px"
                                    containerClass={`${item.IsPrimaryNumber ? "icon-container" : "hidden"}`}
                                />
                               :
                                <div className="tab-details-label">
                                    <span>
                                       <Translation translationKey="secondary" />
                                    </span>
                               </div>
                                    
                            }
                            {toggleTab === DASHBOARD_TAB.FixedLineWireLine ? 
                                <>
                                    <h2 className="tab-details-office tab-details-location-site">{this.getLocationAndZipCode(item.Location, item.LocationZip)}</h2>
                                    <h2 className="tab-details-location-country">{this.getCityAndCountryCode(item.LocationCity, item.LocationCountryCode)}</h2>
                                </> : ""}
                        </div>
                    </div>
                )
            );
        } 
    }
}